// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-body.central[data-v-5836189d] {
  padding: 0 16px 18px 16px;
}
.main-body.central[data-v-5836189d] .main-content-container {
  margin: 20px auto 0 auto;
  flex-basis: auto !important;
  background: var(--bg-color);
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.1) 0 1px 3px 0, rgba(0, 0, 0, 0.15) 0 1px 3px 1px !important;
}
.main-body.central[data-v-5836189d] .main-content-container .main-content-container-header {
  margin-bottom: 0px;
  padding-top: 12px;
  padding-left: 12px;
  font-size: 16px;
  font-weight: 600;
}
.main-body.central[data-v-5836189d] .main-content-container .main-content-container-main {
  background: inherit;
  box-shadow: none;
  margin-bottom: 0px;
}
.new-version-header[data-v-5836189d],
.new-version-changes[data-v-5836189d],
.new-version-install[data-v-5836189d] {
  cursor: initial !important;
  padding-top: 0.5em;
}
.new-version-header .item-content[data-v-5836189d]:after,
.new-version-changes .item-content[data-v-5836189d]:after,
.new-version-install .item-content[data-v-5836189d]:after {
  content: none !important;
}
.new-version-install[data-v-5836189d] {
  display: flex;
  flex-direction: column;
}
.new-version-install .link[data-v-5836189d] {
  width: fit-content;
  margin-top: -6px;
}
.new-version-install .footerText[data-v-5836189d] {
  line-height: 1em;
  margin-bottom: 0.6em;
}
.left-slot[data-v-5836189d] {
  height: 48px;
  width: 48px;
  display: flex;
}
.status-icon[data-v-5836189d],
.update-icon[data-v-5836189d] {
  margin: auto;
  text-align: center;
  font-size: 20px;
}
.status-icon.status-icon.fa-check-circle[data-v-5836189d],
.update-icon.status-icon.fa-check-circle[data-v-5836189d] {
  color: green;
}
.status-icon.status-icon.fa-check-circle.gray[data-v-5836189d],
.update-icon.status-icon.fa-check-circle.gray[data-v-5836189d] {
  color: gray;
}
.status-icon.update-icon[data-v-5836189d],
.update-icon.update-icon[data-v-5836189d] {
  color: var(--modal-elem-color);
  font-size: 18px;
}
.new-version-changes[data-v-5836189d] {
  word-break: break-word;
  white-space: pre-wrap;
  height: auto;
  padding-top: 2.4em;
  padding-bottom: 0.7em;
}
.new-version-install[data-v-5836189d] {
  color: var(--modal-elem-color);
}
.footer-link a[data-v-5836189d] {
  font-size: initial;
  color: var(--modal-elem-color);
  cursor: pointer;
}
.footer-link a[data-v-5836189d]:hover {
  color: var(--modal-elem-color);
  text-decoration: none;
}
.footer-link[data-v-5836189d] .link {
  min-height: auto;
  height: auto;
}
.footer-link[data-v-5836189d] .item-content .item-text {
  margin-left: 0;
}
.footer-link[data-v-5836189d] .item-content::after {
  border-bottom: none !important;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/main/body/MainContentAbout.vue"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,2BAA2B;EAC3B,kBAAkB;EAClB,wFAAwF;AAC1F;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;EAGE,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;;;EAGE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;AACf;AACA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,8BAA8B;AAChC","sourcesContent":[".main-body.central[data-v-5836189d] {\n  padding: 0 16px 18px 16px;\n}\n.main-body.central[data-v-5836189d] .main-content-container {\n  margin: 20px auto 0 auto;\n  flex-basis: auto !important;\n  background: var(--bg-color);\n  border-radius: 4px;\n  box-shadow: rgba(0, 0, 0, 0.1) 0 1px 3px 0, rgba(0, 0, 0, 0.15) 0 1px 3px 1px !important;\n}\n.main-body.central[data-v-5836189d] .main-content-container .main-content-container-header {\n  margin-bottom: 0px;\n  padding-top: 12px;\n  padding-left: 12px;\n  font-size: 16px;\n  font-weight: 600;\n}\n.main-body.central[data-v-5836189d] .main-content-container .main-content-container-main {\n  background: inherit;\n  box-shadow: none;\n  margin-bottom: 0px;\n}\n.new-version-header[data-v-5836189d],\n.new-version-changes[data-v-5836189d],\n.new-version-install[data-v-5836189d] {\n  cursor: initial !important;\n  padding-top: 0.5em;\n}\n.new-version-header .item-content[data-v-5836189d]:after,\n.new-version-changes .item-content[data-v-5836189d]:after,\n.new-version-install .item-content[data-v-5836189d]:after {\n  content: none !important;\n}\n.new-version-install[data-v-5836189d] {\n  display: flex;\n  flex-direction: column;\n}\n.new-version-install .link[data-v-5836189d] {\n  width: fit-content;\n  margin-top: -6px;\n}\n.new-version-install .footerText[data-v-5836189d] {\n  line-height: 1em;\n  margin-bottom: 0.6em;\n}\n.left-slot[data-v-5836189d] {\n  height: 48px;\n  width: 48px;\n  display: flex;\n}\n.status-icon[data-v-5836189d],\n.update-icon[data-v-5836189d] {\n  margin: auto;\n  text-align: center;\n  font-size: 20px;\n}\n.status-icon.status-icon.fa-check-circle[data-v-5836189d],\n.update-icon.status-icon.fa-check-circle[data-v-5836189d] {\n  color: green;\n}\n.status-icon.status-icon.fa-check-circle.gray[data-v-5836189d],\n.update-icon.status-icon.fa-check-circle.gray[data-v-5836189d] {\n  color: gray;\n}\n.status-icon.update-icon[data-v-5836189d],\n.update-icon.update-icon[data-v-5836189d] {\n  color: var(--modal-elem-color);\n  font-size: 18px;\n}\n.new-version-changes[data-v-5836189d] {\n  word-break: break-word;\n  white-space: pre-wrap;\n  height: auto;\n  padding-top: 2.4em;\n  padding-bottom: 0.7em;\n}\n.new-version-install[data-v-5836189d] {\n  color: var(--modal-elem-color);\n}\n.footer-link a[data-v-5836189d] {\n  font-size: initial;\n  color: var(--modal-elem-color);\n  cursor: pointer;\n}\n.footer-link a[data-v-5836189d]:hover {\n  color: var(--modal-elem-color);\n  text-decoration: none;\n}\n.footer-link[data-v-5836189d] .link {\n  min-height: auto;\n  height: auto;\n}\n.footer-link[data-v-5836189d] .item-content .item-text {\n  margin-left: 0;\n}\n.footer-link[data-v-5836189d] .item-content::after {\n  border-bottom: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
